import React, { useState } from "react";
import { FiMail, FiPhone, FiMapPin, FiSend, FiLoader } from "react-icons/fi";
import axios from "axios";
import toast from "react-hot-toast"; // react-hot-toast import করুন

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSending, setIsSending] = useState(false);

  const newPrimaryAccentColor = "#e5272e";
  const gradientColor = "linear-gradient(to right, #e5272e, #f59332)";
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- Client-Side Validation ---
    if (formData.name.length < 2) {
      toast.error("Name must be at least 2 characters long.");
      return;
    }
    if (formData.subject.length < 5) {
      toast.error("Subject must be at least 5 characters long.");
      return;
    }
    if (formData.message.length < 10) {
      toast.error("Message must be at least 10 characters long.");
      return;
    }

    setIsSending(true);
    try {
      const response = await axios.post(
        `${baseUrl}contact/submit`,
        formData
      );
      toast.success(response.data.message);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <style>
        {`
                .contact-page-section { background-color: #f8f9fa; }
                .contact-hero {
                    background-color: ${newPrimaryAccentColor};
                    color: #ffffff; padding: 4rem 0;
                    border-bottom-left-radius: 40px; border-bottom-right-radius: 40px;
                }
                .contact-hero h1 { font-size: 3rem; font-weight: 700; text-shadow: 1px 1px 2px rgba(0,0,0,0.2); }
                .contact-hero p { font-size: 1.15rem; color: rgba(255, 255, 255, 0.9); }
                .contact-form-card, .contact-info-card {
                    background-color: #ffffff; border-radius: 16px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
                    padding: 2.5rem; height: 100%;
                }
                .contact-form-card h3, .contact-info-card h3 {
                    color: ${newPrimaryAccentColor}; font-weight: 700;
                    margin-bottom: 1.75rem; display: flex; align-items: center;
                    font-size: 1.5rem;
                }
                .contact-form-card h3 svg, .contact-info-card h3 svg {
                    margin-right: 12px; font-size: 1.6rem;
                }
                .form-control-contact {
                    border-radius: 8px; border: 1px solid #d1d5db;
                    padding: 0.9rem 1rem; transition: border-color 0.2s ease, box-shadow 0.2s ease;
                    font-size: 0.95rem;
                }
                .form-control-contact:focus {
                    border-color: ${newPrimaryAccentColor};
                    box-shadow: 0 0 0 0.25rem rgba(229, 39, 46, 0.2);
                    background-color: #fff;
                }
                .form-label-contact {
                    font-weight: 600; color: #374151;
                    margin-bottom: 0.6rem; font-size: 0.9rem;
                }
                .btn-submit-contact {
                    background-image: ${gradientColor}; color: white; border: none;
                    padding: 0.9rem 1.75rem; border-radius: 50px; font-weight: 700;
                    font-size: 1.05rem; transition: opacity 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
                    display: inline-flex; align-items: center; justify-content: center;
                    width: 100%; box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                }
                .btn-submit-contact:hover:not(:disabled) {
                    opacity: 0.85; color: white; transform: translateY(-3px);
                    box-shadow: 0 6px 15px rgba(229, 39, 46, 0.25);
                }
                .btn-submit-contact:disabled { cursor: not-allowed; opacity: 0.7; }
                .btn-submit-contact svg { margin-left: 10px; }
                .contact-info-item {
                    display: flex; align-items: flex-start;
                    margin-bottom: 1.75rem; color: #4b5563;
                }
                .contact-info-item svg {
                    font-size: 1.6rem; color: ${newPrimaryAccentColor};
                    margin-right: 18px; margin-top: 4px; flex-shrink: 0;
                }
                .contact-info-item p { margin-bottom: 0.3rem; line-height: 1.65; font-size: 0.95rem; }
                .contact-info-item strong { color: #1f2937; font-weight: 600; }
                .contact-info-item a { color: ${newPrimaryAccentColor}; text-decoration: none; font-weight: 500; }
                .contact-info-item a:hover { text-decoration: underline; opacity: 0.8; }
                .opening-hours strong { color: #10b981; font-weight: 700; }
                .spinner { animation: spin 1s linear infinite; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                `}
      </style>

      <div className="contact-page-section">
        <section className="contact-hero text-center">
          <div className="container">
            <h1>Get In Touch</h1>
            <p className="lead col-md-9 mx-auto">
              We're here to help and answer any question you might have. We look
              forward to hearing from you!
            </p>
          </div>
        </section>

        <section className="py-5">
          <div className="container">
            <div className="row g-4 g-lg-5 justify-content-center">
              <div className="col-lg-7 col-md-10">
                <div className="contact-form-card">
                  <h3>
                    <FiSend /> Send Us a Message
                  </h3>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="name"
                          className="form-label form-label-contact"
                        >
                          Your Name
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-contact"
                          id="name"
                          placeholder="e.g. John Doe"
                          required
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="email"
                          className="form-label form-label-contact"
                        >
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-contact"
                          id="email"
                          placeholder="e.g. john.doe@example.com"
                          required
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="subject"
                        className="form-label form-label-contact"
                      >
                        Subject
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-contact"
                        id="subject"
                        placeholder="What is your message about?"
                        required
                        value={formData.subject}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        htmlFor="message"
                        className="form-label form-label-contact"
                      >
                        Your Message
                      </label>
                      <textarea
                        className="form-control form-control-contact"
                        id="message"
                        rows="6"
                        placeholder="Write your detailed message here..."
                        required
                        value={formData.message}
                        onChange={handleInputChange}
                      ></textarea>
                    </div>
                    <div className="d-grid pt-2">
                      <button
                        type="submit"
                        className="btn btn-submit-contact"
                        disabled={isSending}
                      >
                        {isSending ? (
                          <FiLoader className="spinner" size={18} />
                        ) : (
                          "Send Message"
                        )}
                        {!isSending && <FiSend size={18} />}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-lg-5 col-md-10 mt-4 mt-lg-0">
                <div className="contact-info-card">
                  <h3>
                    <FiMapPin /> Contact Information
                  </h3>
                  <div className="contact-info-item">
                    <FiMail />
                    <div>
                      <p>
                        <strong>Email Us</strong>
                      </p>
                      <p>
                        <a href="mailto:Support@booze247.co.uk">
                          Support@booze247.co.uk
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <FiPhone />
                    <div>
                      <p>
                        <strong>Call Us</strong>
                      </p>
                      <p>
                        <a href="tel:+4402921880665">+44 029 2188 0665</a>
                      </p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <FiMapPin />
                    <div>
                      <p>
                        <strong>Our Location</strong>
                      </p>
                      <p>Cardiff, Wales, CF3 2ER, United Kingdom</p>
                    </div>
                  </div>
                  <div className="contact-info-item opening-hours">
                    <FiPhone />
                    <div>
                      <p>
                        <strong>Customer Support</strong>
                      </p>
                      <p>
                        We are <strong>Open 24 hours</strong> to assist you!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
